import React, { useState, useEffect, useRef } from 'react';

import { useIntl, history, getLocale } from 'umi';
import { Table, Col, Row, Progress } from 'tea-component';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import SvgIcon from '@/pages/home/components/SvgIcon';
import GameInfocont from '@/pages/intelligence/components/TableComponents/components/GameInfocont';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import Appannie from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import SensorTower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import { DataSourceBubbleContent } from '@/pages/intelligence/components/DataSourceBubbleContent';
import mscience32 from '@/pages/intelligence/assets/svg/marketprofile/mscience32.svg';
import * as echarts from 'echarts';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import ChartBubble from '@/pages/intelligence/components/ChartBubble';
import moment from 'moment';
import { dataSourceKey } from '@intelligence/pages/Following/_hook/useFollowingOptionList';
const { sortable } = Table.addons;

export default function NewRelease(props: any) {
  const {
    marketName,
    SegmentValue,
    dataSource = dataSourceKey.sensortower,
    time,
    trendLoad,
    trendLoadDetail,
    topGameData1,
    topGameData2,
    gotoGameDetailsPage,
    gameType,
    lineData,
    cr10DetailSearch,
    gotoMarketProfileStats,
    hasCr10Data,
  } = props;
  const [tableColumn, setTableColumn] = useState([]);
  const [trendTime, setTrendTime] = useState(time);
  const { formatMessage } = useIntl();
  const locale = getLocale();
  useEffect(() => {
    getColumns();
  }, [gameType, locale]);

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  useEffect(() => {
    if (!hasCr10Data) return;
    lineChart(lineData);
    const chartDom = document.getElementById('lineChart') as HTMLElement;
    const myChart = echarts.getInstanceByDom(chartDom) as any;
    if (myChart) {
      myChart.getZr().off('click');
      myChart.getZr().on('click', function (param: any) {
        // 获取 点击的 触发点像素坐标
        const pointInPixel = [param.offsetX, param.offsetY];
        // 判断给定的点是否在指定的坐标系或者系列上
        if (myChart.containPixel('grid', pointInPixel)) {
          // 获取到点击的 x轴 下标  转换为逻辑坐标
          const xIndex = myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
          const clickTime = lineData?.xAxis[xIndex];
          if (clickTime) {
            const time = clickTime;
            setTrendTime(time);
            const marketNameEn = marketName || history.location.query.marketNameEn;
            const _params = {
              market: marketNameEn,
              entity_type: SegmentValue,
              start_date: time,
              end_date: time,
            };
            cr10DetailSearch(_params);
          }
        }
      });
      myChart.getZr().on('mousemove', function (params) {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (myChart.containPixel('grid', pointInPixel)) {
          // 将此区域的 鼠标样式变为 小手
          myChart.getZr().setCursorStyle('pointer');
        }
      });
    }
  }, [lineData]);

  const getColumns = () => {
    let columns = [] as any;
    if (gameType == 'mobile') {
      columns = [
        {
          key: 'Rank',
          header: formatMessage({ id: 'dbi_market_top_game' }),
          align: 'left',
          render: (cvm: any) => {
            return (
              <GameInfocont
                data={cvm.list}
                rank={cvm.rank}
                type={'mobile'}
                onClick={() => gotoGameDetailsPage(cvm)}
                rightClickToJumpHref={gotoGameDetailsPage(cvm, '', false)}
              />
            );
          },
        },
        {
          key: 'Revenue($)',
          align: 'right',
          width: 150,
          header: (
            <SortBy
              title={formatMessage({ id: 'dbi_revenue_$' })}
              content={formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
              svgIcon={dataSource === dataSourceKey.sensortower ? SensorTower : Appannie}
              isNoDropdown={true}
              svgTip={
                <DataSourceBubbleContent
                  sourceNameLocalId={formatMessage({ id: 'dbi_revenue_$' })}
                  metric={dataSource}
                  metricKey={'revenue'}
                  entityType={SegmentValue}
                />
              }
            />
          ),
          render: (cvm: any) => {
            return <span className="tabdetails-table-text">{cvm.dau}</span>;
          },
        },
        {
          key: '% of Market',
          header: formatMessage({ id: 'dbi_market_percent' }),
          align: 'right',
          width: 130,
          render: (cvm: any) => {
            return (
              <Progress
                className="tabdetails-progress"
                type="circle"
                percent={cvm.percent}
                strokeWidth={8}
                strokeColor="#376AE7"
              />
            );
          },
        },
      ];
    } else if (gameType == 'pc') {
      columns = [
        {
          key: 'Rank',
          header: formatMessage({ id: 'dbi_market_top_game' }),
          align: 'left',
          width: 260,
          render: (cvm: any) => {
            return (
              <GameInfocont
                data={cvm.list}
                type={'pc'}
                rank={cvm.rank}
                onClick={() => gotoGameDetailsPage(cvm)}
                rightClickToJumpHref={gotoGameDetailsPage(cvm, '', false)}
              />
            );
          },
        },
        {
          key: 'Digital Revenue($)',
          align: 'right',
          width: 195,
          header: (
            <SortBy
              title={formatMessage({ id: 'dbi_metric_digitalRevenue' })}
              svgIcon={mscience32}
              isNoDropdown={true}
              svgTip={
                <DataSourceBubbleContent
                  sourceNameLocalId={'Digital Revenue($)'}
                  metric={'mscience'}
                  metricKey={'digitalRevenue'}
                  entityType={SegmentValue}
                />
              }
              content={formatMessage({ id: 'dbi_info_sum_selected' })}
            />
          ),
          render: (cvm: any) => {
            return <span className="tabdetails-table-text">{cvm.dau}</span>;
          },
        },
        {
          key: '% of Market',
          header: formatMessage({ id: 'dbi_market_percent' }),
          align: 'right',
          width: 140,
          render: (cvm: any) => {
            return (
              <Progress
                className="tabdetails-progress"
                type="circle"
                percent={cvm.percent}
                strokeWidth={8}
                strokeColor="#376AE7"
              />
            );
          },
        },
      ];
    } else if (gameType == 'console') {
      columns = [
        {
          key: 'Rank',
          header: formatMessage({ id: 'dbi_market_top_game' }),
          align: 'left',
          render: (cvm: any) => {
            return (
              <GameInfocont
                data={cvm.list}
                type={'console'}
                rank={cvm.rank}
                iconList={cvm.platList}
                onClick={() => gotoGameDetailsPage(cvm)}
                rightClickToJumpHref={gotoGameDetailsPage(cvm, '', false)}
              />
            );
          },
        },
        {
          key: 'Digital Revenue($)',
          align: 'right',
          width: 195,
          header: (
            <SortBy
              title={formatMessage({ id: 'dbi_metric_digitalRevenue' })}
              svgIcon={mscience32}
              isNoDropdown={true}
              svgTip={
                <DataSourceBubbleContent
                  sourceNameLocalId={formatMessage({ id: 'dbi_metric_digitalRevenue' })}
                  metric={'mscience'}
                  metricKey={'digitalRevenue'}
                  entityType={SegmentValue}
                />
              }
              content={formatMessage({ id: 'dbi_info_sum_selected' })}
            />
          ),
          render: (cvm: any) => {
            return <span className="tabdetails-table-text">{cvm.dau}</span>;
          },
        },
        {
          key: '% of Market',
          header: formatMessage({ id: 'dbi_market_percent' }),
          align: 'right',
          width: 140,
          render: (cvm: any) => {
            return (
              <Progress
                className="tabdetails-progress"
                type="circle"
                percent={cvm.percent}
                strokeWidth={8}
                strokeColor="#376AE7"
              />
            );
          },
        },
      ];
    }
    setTableColumn(columns);
  };

  // 窗口变化调整布局
  const resizeHandler = () => {
    const mapChartDom = document.getElementById('lineChart');
    if (mapChartDom) {
      const myMapChart = echarts.init(mapChartDom);
      try {
        myMapChart.resize();
      } catch (e) {}
    }
  };

  function lineChart(data: any) {
    if (document.getElementById('lineChart')) {
      const chartDom = document.getElementById('lineChart') as HTMLElement;
      let mychart = echarts.getInstanceByDom(chartDom);
      if (mychart == null) {
        mychart = echarts.init(chartDom);
      }
      const barFormatterTooltip = (params: any) => {
        return ChartBubble({
          data: params,
          headerLeftTitle: params[0].name,
          headerRightTitle: 'Revenue($)',
          // titleNow,
          topChartsType: 'marketProfile-insight-bar',
          imageType: 'mobile',
          chartType: 'line',
          dateType: 'month',
          // rightContent:formatNum(Math.floor(totalNum)),
          ifNoBarImg: true,
        });
      };
      const option = {
        title: {
          show: false,
          text: 'Market CR10 By Revenue',
          left: '0',
          textStyle: {
            color: '#000',
            fontWeight: 'bold',
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#BBBBBB',
            },
          },
          padding: 0,
          borderWidth: 0,
          formatter: barFormatterTooltip,
          backgroundColor: 'rgba(0,0,0,0)'
        },
        grid: {
          left: '3%',
          bottom: 60,
          top: 20,
          right: '3%',
        },
        legend: {
          show: true,
          bottom: 10,
          lineStyle: {
            opacity: 0,
          },
          icon: 'circle',
          itemWidth: 8,
        },
        xAxis: {
          type: 'category',
          data: data.xAxis,
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: '#0076FF',
              opacity: '0.05',
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            position: 'left',
            axisLine: {
              show: false,
            },
            splitNumber: 5,
            axisLabel: {
              color: '#bbbbbb',
              formatter(value, index) {
                return formatNum(value);
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#eeeeee',
              },
            },
          },
          {
            type: 'value',
            position: 'right',
            axisLine: {
              show: false,
            },
            splitNumber: 5,
            axisLabel: {
              color: '#bbbbbb',
              formatter(value, index) {
                return formatPercentNum(value);
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#eeeeee',
              },
            },
          },
        ],
        series: data.series,
      };
      mychart.resize();
      option && mychart.setOption(option);
    }
  }

  return (
    <div>
      {hasCr10Data ? (
        <div className="tabdetails-echarts" style={{ height: 320 }} id="lineChart" />
      ) : (
        <div style={{ height: 320 }}>
          <NoData height="100%" title="No trends data under current selections." />
        </div>
      )}

      <div className="tabdetails-gamehead">
        <div className="tabdetails-gamehead-title" onClick={gotoMarketProfileStats}>
          {formatMessage({ id: 'dbi_market_top_game' })}
          <SvgIcon type="arrow-right" className="card-sort-icon" />
          {/* <SvgIcon className="tabdetails-gamehead-arrow" type={''} /> */}
        </div>
        <div className="tabdetails-gamehead-text">{moment(trendTime).format('MMM DD,YYYY')}</div>
      </div>

      <Row className="insights-rowtop">
        <Col span={12}>
          {trendLoad || trendLoadDetail ? (
            <div style={{ height: 425 }}>
              <Loading content={formatMessage({ id: 'common_loading' })} />
            </div>
          ) : topGameData1.length == 0 ? (
            <div style={{ height: 425 }}>
              <NoData height="100%" title="No trends data under current selections." />
            </div>
          ) : (
            <Table
              className="tabdetails-table"
              records={[...topGameData1]}
              columns={tableColumn}
              addons={[]}
            />
          )}
        </Col>
        <Col span={12}>
          {trendLoad || trendLoadDetail ? (
            <div style={{ height: 425 }}>
              <Loading content={formatMessage({ id: 'common_loading' })} />
            </div>
          ) : topGameData2.length == 0 ? (
            <div style={{ height: 425 }}>
              <NoData height="100%" title="No trends data under current selections." />
            </div>
          ) : (
            <Table
              className="tabdetails-table"
              records={[...topGameData2]}
              columns={tableColumn}
              addons={[]}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}
